import { NgModule } from '@angular/core'
import { TaiyuanCollegeLeafletComponent } from '@components/taiyuan-college-leaflet/taiyuan-college-leaflet.component'

@NgModule({
  declarations: [TaiyuanCollegeLeafletComponent],
  imports: [],
  exports: [TaiyuanCollegeLeafletComponent],
})
export class TaiyuanCollegeLeafletModule {}
